import moment from 'moment';

const isMonthlyMowingDisabled = (market) => {
  if (
    !market ||
    !market.hasOwnProperty('mowing_monthly_disabled_starts_at') ||
    !market.hasOwnProperty('mowing_monthly_disabled_ends_at')
  ) {
    return true;
  }

  const { mowing_monthly_disabled_starts_at, mowing_monthly_disabled_ends_at } = market;
  if (!mowing_monthly_disabled_starts_at || !mowing_monthly_disabled_ends_at) {
    return true;
  }

  return moment().isBetween(mowing_monthly_disabled_starts_at, mowing_monthly_disabled_ends_at);
};

export const lsMarketHelpers = {
  isMonthlyMowingDisabled,
};
